export default __webpack_public_path__ + "static/media/screen_whatsapp_4.7fc80169.png";